import { ResumeProfileAnalysis } from "../resume-analyse-types";

import { endsWithPeriod } from "../analysis-utils/endsWithPeriod";
import { removeActionVerbs } from "../analysis-utils/removeActionVerbs";
import { removeSpellingMistakes } from "../analysis-utils/removeSpellingMistakes";
import matcher from "../analysis-utils/findWords";
import { countWords } from "../analysis-utils/countWords";

const analyseProfile = (
  profile: ResumeProfileAnalysis
): ResumeProfileAnalysis => {
  return {
    ...profile,
    summaryAnalysis: {
      ...profile.summaryAnalysis,
      analysis: {
        ...profile.summaryAnalysis.analysis,
        // 1. Check and Remove Action Verbs that are not present in the profile summary.
        actionVerbAnalysis: removeActionVerbs(
          profile.summaryAnalysis.statement,
          profile.summaryAnalysis.analysis.actionVerbAnalysis
        ),
        // 2. Check and Remove Spelling Mistakes that are not present in the profile summary.
        spellingMistakes: removeSpellingMistakes(
          profile.summaryAnalysis.statement,
          profile.summaryAnalysis.analysis.spellingMistakes
        ),
        // 3. Find the Buzz Words that are present in the profile summary using the buzz words JSON.
        buzzWords: matcher.search(profile.summaryAnalysis.statement),
        // 4. Find the Filler Words that are present in the profile summary using the filler words JSON.
        fillerWords: matcher.search(profile.summaryAnalysis.statement),
        // 5. Check if the profile summary ends with a period.
        endsWithPeriod: endsWithPeriod(profile.summaryAnalysis.statement),
        //6. Count the number of words in the summary
        bulletPointWords: countWords(profile?.summaryAnalysis?.statement),
      },
    },
  };
};

export { analyseProfile };
